import { Box, Skeleton } from '@frontend-workspace/react-shared-lib';

export function EditEmailSkeleton() {
  return (
    <Box>
      <div className="pt-4 mb-4">
        <Skeleton animation="wave" width={150} height={50} />
      </div>
      <div className="d-flex flex-wrap mb-1">
        <Skeleton className="me-3" animation="wave" width={250} height={50} />
        <Skeleton animation="wave" width={250} height={50} />
      </div>
      <Skeleton className='mb-3' variant="rectangular" animation="wave" width='100%' height={450} />
      <Skeleton className='mb-3' variant="rectangular" animation="wave" width={300} height={300} />
      <Skeleton className='mb-3' animation="wave" width={200} height={50} />
      <Skeleton animation="wave" width={150} height={50} />
    </Box>
  );
}

export default EditEmailSkeleton;